import React, { useState, useEffect } from "react";
import axios from "axios";
import Modal from 'react-bootstrap/Modal';
import Swal from 'sweetalert2'
import { Container, Row, Col, Form, Button, ProgressBar } from "react-bootstrap"
import exportValue from "../../apiconfig";
import Left_panel from '../Left_panel';
import Sub_header from '../Sub_header';
import '../../components/loader.css';
import { useNavigate } from 'react-router-dom'
import TablePagination from '@mui/material/TablePagination';
import ReactLoading from 'react-loading';
import moment from 'moment'
import * as XLSX from 'xlsx'
import html2pdf from 'html2pdf.js';

const Customer_invoices = () => {
    let navigate = useNavigate()
    const[state , setState ] = React.useState([])
    const[isLoading , setisLoading] = React.useState(true)
    const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
    const[date, setdate] = React.useState({from_date:moment().subtract(30, 'days').format('YYYY-MM-DD'),to_date:moment().format('YYYY-MM-DD')})
    const[stateshipments , setShipments] = React.useState([])
    const[statecompany , setcompanyState ] = React.useState()
    console.log("statecompany == " ,statecompany )
    const[selected , setSelected] = React.useState({select_count:0 , select_order_id:[]})
    console.log("selected == " , selected)
          const[statecustomer,setStatecustomer]= React.useState()
    const[isLoadingprint , setisLoadingprint] = React.useState(false)
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
        const homeSection = document.querySelector('.home-section');
        if (homeSection) {
            homeSection.classList.toggle('sidebar-closed');
        }
    };
    React.useEffect(()=>{
        invoice_list()
         shipment_list()
    },[])

    const shipment_list=()=>{
      let dataToSend = {
  };
 
    console.log("datatoSend",dataToSend)
    let url = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + '/invoice_details_company';
    axios.post(url, dataToSend, { headers: exportValue.headers })
        .then((res) => {
          console.log("responseJson => ", res);
          if(res.data.status == true){
            setcompanyState(res.data.output)
        
          }

       
        })
        .catch((error) => {
            //Hide Loader
          //   setLoadingstate({...loadingstate,loading:false})
            console.log(error);
        });    

  }

    const invoice_list=(status,index=0,onLoad)=>{
        let dataToSend = {
    };
    if(date.from_date!="" && date.to_date!=""){
        dataToSend.from_date = date.from_date
        dataToSend.to_date = date.to_date
  
      }
    let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/customer_invoices`;
   
    
    axios.post(full_api, dataToSend, { headers: exportValue.headers })
          .then((res) => {
            // console.log("responseJson => ", res);
           
            setState(res.data.output)
            setisLoading(false)
         
          })
          .catch((error) => {
              //Hide Loader
            //   setLoadingstate({...loadingstate,loading:false})
              // console.log(error);
          });    

    }
    const next_step = (sub)=>{
        // navigate({
        //   pathname: '/invoice_detail',
        //   search: `invoice_id=${sub.invoice_id}&invoice_date=${sub.invoice_date}&amount=${sub.amount}&customer_id=${sub.customer_id}`
        // })
        const url = `/invoice_detail?invoice_id=${sub.invoice_id}&invoice_date=${sub.invoice_date}&amount=${sub.amount}&customer_id=${sub.customer_id}&invoice_period=${sub.invoice_period}&cod_verification_amount=${sub.cod_verification_amount}&delivery_update_amount=${sub.delivery_update_amount}&item_total=${sub.item_total}`;
        
        // Open the URL in a new tab
        window.open(url, '_blank');
      }
      const dateselect =(e)=>{
        setdate({...date,[e.target.name]:e.target.value})
     }


     const get_shipments = (sub)=>{
        let dataToSend = {
invoice_id:sub.invoice_id,customer_id:sub.customer_id
        };
          let url = exportValue.host + "/" + exportValue.version + "/" + exportValue.api  + '/get_invoice_shipments';
           axios.post(url, dataToSend, { headers:  exportValue.headers  })
              .then((res) => {
              
                setShipments(res.data.output)
                downloadExcel(res.data.output)
              })
              .catch((error) => {
                 
              });    
     } 
     const transformDataForExcel = (data) => {
        return data.map(item => {
          console.log("created == ", item.created)
          const formattedDate = item.created
            ? new Date(item.created * 1000).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
            })
            : '';
    
          const formattedTime = item.created
            ? new Date(item.created * 1000).toLocaleTimeString('en-US', {
              hour: 'numeric',
              minute: 'numeric',
              second: 'numeric',
              hour12: true,
            })
            : '';
          return {
            'Tracking Id': item?.carrier_tracking_number || '',
            'Reference Number': item?.order_number || '',
            'Carrier': item?.carrier_name || '',
            'Mode':  item?.product_type_name || '',
            'Carrier Product': item?.service_provider || '',
            'Current Status': getStatusText(item?.status) || '',
           
          }
        });
      };
    
      const getStatusText = (status) => {
        // Define your status mappings here
        const statusMappings = {
          0: 'Pending',
          10: 'RTO',
          1: 'Pick Up Awaited',
          2: 'Picked Up',
          3: 'In Transit',
          4: 'Out For Delivery',
          5: 'Delivered',
          6: 'Cancelled',
          7: 'Failed',
          8: 'NDR',
          9: 'Pickup Scheduled',
          15:'Booked'
    
        };
    
    
        return statusMappings[status] || '';
      }

      const downloadExcel = (items) => {
        const data = transformDataForExcel(items);
        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Invoice AWb');
        XLSX.writeFile(wb, 'Invoice AWb.xlsx');
      };
      const calculateDueDate = (invoiceDate, days) => {
        const date = new Date(invoiceDate);
        date.setDate(date.getDate() + days);
        return date.toISOString().split('T')[0]; // Format as YYYY-MM-DD
      };
      
      const getInvoicePeriod = (invoicePeriod) => {
        const [monthName, year] = invoicePeriod.split(',');
        const monthIndex = new Date(`${monthName} 1, ${year}`).getMonth();
        const startDate = new Date(year, monthIndex, 1);
        const endDate = new Date(year, monthIndex + 1, 0);
      
        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };
      
        return `${formatDate(startDate)} to ${formatDate(endDate)}`;
      };
      const generateCombinedHTML = (sub,statecompany) => {
        const remainingAmount = sub.amount / 1.18; // Example calculation for remaining amount
        const gstAmount = sub.amount - remainingAmount;
          return `
    <div class="container wrap" >
      <div class="card mb-1 ">
        <div class="card-body">
          <div class="pb-2">
            <img src="../../../assets/img/logo_5.png" class="img-fluid" style="height:50px;"/>
          </div>
          <div class="row">
            <div class="col-7">
              <div class="pb-2" style="font-size:10px;">
                <strong >${statecompany.invoice_name?statecompany.invoice_name:statecompany.company_name?statecompany.company_name:""}</strong><br/>
                ${statecompany.invoice_address?statecompany.invoice_address:statecompany.company_address?statecompany.company_address:""}<br/>
                Phone: ${statecompany.invoice_phone?statecompany.invoice_phone:statecompany.phone?statecompany.phone:""}<br/>
                Email: ${statecompany.invoice_email?statecompany.invoice_email:statecompany.email?statecompany.email:""}
              </div>
              <div style="font-size:10px;">
                <strong>PAN Number:</strong> ${statecompany.invoice_pan?statecompany.invoice_pan:""}<br/>
                <strong>CIN Number:</strong> ${statecompany.invoice_cin?statecompany.invoice_cin:""}<br/>
                <strong>GSTIN:</strong> ${statecompany.invoice_gst?statecompany.invoice_gst:""}<br/>
                <strong>IRN:</strong> ${statecompany.invoice_irn?statecompany.invoice_irn:""}
              </div>
            </div>
            <div class="col-5" style="font-size:10px;">
              <h6 class="pb-2"><strong>TAX INVOICE</strong></h6>
              <h2 class="text-success">PAID</h2>
             
              <div class="pt-2">
                <strong>Invoice No. :</strong> ${sub.invoice_id}<br/>
                <strong>Invoice Date :</strong> ${sub.invoice_date}<br/>
                <strong>Due Date :</strong> ${calculateDueDate(sub.invoice_date, 15)}<br/>
                <strong>Invoice Period : </strong> ${getInvoicePeriod(sub.invoice_period)}
              </div>
            </div>
          </div>
          <hr/>
          <div class="row">
            <div class="col-7" style="font-size:10px;">
              <strong>Invoice To:</strong>
              ${sub.company_name ? sub.company_name : sub.full_name ? sub.full_name : ""} <br/>
              ${sub.address?sub.address:""}
            </div>
            <div class="col-5" style="font-size:10px;">
              <strong>GSTIN:</strong> ${sub.gst_number ? sub.gst_number : ""} <br/>
            </div>
          </div>
        </div>
      </div>

      <div class="card mb-1">
        <div class="card-body" style="font-size:10px;">
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>SAC No.</th>
                  <th>Description</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>996812</td>
                  <td>Courier Services</td>
                  <td>${remainingAmount.toFixed(2)}</td>
                </tr>
                <tr>
                  <td></td>
                  <td>18.00% IGST</td>
                  <td>${gstAmount.toFixed(2)}</td>
                </tr>
                <tr>
                  <td></td>
                  <td class="fw-bold">Grand Total Value</td>
                  <td>${sub.amount}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-body" style="font-size:10px;">
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Transaction Date</th>
                  <th>Gateway</th>
                  <th>Transaction ID</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>${sub.invoice_date}</td>
                  <td>Wallet</td>
                  <td>NA</td>
                  <td>${sub.amount}</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td class="fw-bold">Amount Due</td>
                  <td>0.00</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="card mb-1">
        <div class="card-body" style="font-size:10px;">
          <div class="border-bottom py-2">
            <strong>Bank and Other Commercial Details</strong>
          </div>
          <div>
            All Payments by transfer/check/DD should be draw in favour of <br/>
            <strong>Entity Name:</strong> ${statecompany.entity_name?statecompany.entity_name:""} <br/>
            <strong>Account number:</strong> ${statecompany.account_number?statecompany.account_number:""} <br/>
            <strong>Bank:</strong> ${statecompany.bank?statecompany.bank:""} <br/>
            <strong>Branch:</strong> ${statecompany.branch?statecompany.branch:""} <br/>
            <strong>RTGS/NEFT/IFSC Code:</strong> ${statecompany.ifsc_code?statecompany.ifsc_code:""}
          </div>
        </div>
      </div>
    </div>
  `;
        
    
        
      };
    
     

      // const handleBulkPrint = async () => {
      //   setisLoadingprint(true); // Show loader
      
      //   // Delay execution slightly to allow React to update the state and show the loader
      //   setTimeout(async () => {
      //     try {
      //       const pdfPromises = selected.select_order_id.map((invoice) =>
      //         generateInvoicePDF(invoice, statecompany)
      //       );
      
      //       await Promise.all(pdfPromises); // Wait for all PDFs to be generated
      //       console.log("All PDFs have been generated and downloaded.");
      //     } catch (error) {
      //       console.error("Error generating PDFs:", error);
      //     } finally {
      //       setisLoadingprint(false); // Hide loader after processing
      //     }
      //   }, 100); // Small delay to allow UI update
      // };

      const handleBulkPrint = async () => {
        setisLoadingprint(true); // Show loader
      
        try {
          for (const invoice of selected.select_order_id) {
            await generateInvoicePDF(invoice, statecompany);
          }
      
          console.log("All PDFs have been generated and downloaded.");
        } catch (error) {
          console.error("Error generating PDFs:", error);
        } finally {
          setisLoadingprint(false); // Hide loader after processing
        }
      };
      
      
      // const generateInvoicePDF = (invoice, statecompany) => {
      //   // Generate the HTML for the invoice
      //   const invoiceHTML = generateCombinedHTML(invoice, statecompany);
      
      //   // Create a temporary container to hold the HTML
      //   const tempContainer = document.createElement('div');
      //   tempContainer.innerHTML = invoiceHTML;
      
      //   // Convert the HTML to PDF
      //   html2pdf()
      //     .from(tempContainer)
      //     .set({
      //       margin: 10,
      //       filename: `invoice_${invoice.invoice_id}.pdf`, // Unique filename for each invoice
      //       image: { type: 'jpeg', quality: 0.98 },
      //       html2canvas: { scale: 2 },
      //       jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
      //     })
      //     .save();
      // };

      const generateInvoicePDF = (invoice, statecompany) => {
        return new Promise((resolve) => {
          const invoiceHTML = generateCombinedHTML(invoice, statecompany);
      
          const tempContainer = document.createElement('div');
          tempContainer.innerHTML = invoiceHTML;
          
      
          html2pdf()
            .from(tempContainer)
            .set({
              margin: 10,
              filename: `${invoice.invoice_id}.pdf`,
              image: { type: 'jpeg', quality: 0.98 },
              html2canvas: { scale: 2 },
              jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
            })
            .save()
            .then(() => resolve());
        });
      };

      const handleSelectAll = (event) => {
        const isChecked = event.target.checked;
      
        const selectedData = isChecked ? state.map(invoice => invoice) : [];
      
        setSelected({
          select_count: selectedData.length,
          select_order_id: selectedData,
        });
      };
      
      const handleChangeSelected = (e, sub) => {
        setSelected(prevSelected => {
          const isAlreadySelected = prevSelected.select_order_id.some(item => item.invoice_id === sub.invoice_id);
      
          if (isAlreadySelected) {
            // Remove the selected invoice
            const updatedSelection = prevSelected.select_order_id.filter(item => item.invoice_id !== sub.invoice_id);
            return {
              select_count: updatedSelection.length,
              select_order_id: updatedSelection,
            };
          } else {
            // Add the selected invoice
            return {
              select_count: prevSelected.select_count + 1,
              select_order_id: [...prevSelected.select_order_id, sub],
            };
          }
        });
      };

      const downloadExcelInvoice = () => {
        if (!state || state.length === 0) return;
      
        // Prepare clean data (NO checkbox, NO action)
        const excelData = state.map((sub) => ({
          "Invoice No": sub.invoice_id,
          "Customer": sub.company_name || sub.full_name || "",
          "State": sub.state_name || "",
          "GST / PAN":
            sub.gst_number && sub.gst_number !== "undefined"
              ? ` ${sub.gst_number}`
              : sub.pan_number
              ? ` ${sub.pan_number}`
              : "",
          "Invoice Date": sub.invoice_date,
          "Invoice Period": sub.invoice_period,
          "Invoice Amount": sub.amount || 0,
        }));
      
        // Convert JSON → Sheet
        const worksheet = XLSX.utils.json_to_sheet(excelData);
      
        // Create Workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Invoices");
      
        // Download file
        XLSX.writeFile(workbook, "Invoices.xlsx");
      };
  return (
    <div>
  <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      
      <section class="home-section">
               {/* <?php
               include('sub_header.php');
               ?> 
            */}
       <Sub_header/>
    
           <div className=''>
        <section class="mt-3">
        <div class="row mb-3">
            <div class="col-12 col-md-4">
                <h5>Invoices</h5>
            </div>
            <div class="col-12 col-md-2">
                    <input type="date" class="form-control form-control-sm" id="text" placeholder="Enter details name=" name="from_date" value={date.from_date}  onChange={(e)=>dateselect(e)}/>
                    </div>
                    <div class="col-12 col-md-2">
                    <input type="date" class="form-control form-control-sm" id="text" placeholder="Enter details name=" name="to_date" value={date.to_date}  onChange={(e)=>dateselect(e)}/>
                    </div>
                    <div class="col-12 col-md-1">
                       <button className='btn btn-primary g-1' onClick={()=>invoice_list()}>Search</button>
                    </div>
                    <div class="col-12 col-md-3">
                       <button className='btn btn-primary g-1' onClick={downloadExcelInvoice} >Download Excel</button>
                    </div>
                    <div className="col-12 col-md-2">
                    {selected.select_count==0?"":   isLoadingprint?  <ReactLoading type={"spin"} color={"#0d6efd"} height={40} width={60} />: <a type="button" class="btn btn-outline-primary me-2" onClick={handleBulkPrint}>
                    Download Invoices
      </a>}
                    </div>
                    
        </div>
        {isLoading? 
                        <div style={{ display: 'flex', justifyContent: 'center', marginLeft:"60px", alignItems: 'center',marginTop:"-200px", height: '100vh' }}>
                        <ReactLoading type={"spin"} color={"#0d6efd"} height={40} width={60} />
                        </div>:
            <div class="card card-body border-0 shadow table-wrapper table-responsive ">
                <table class="table table-hover  shipm_tablew">
                    <thead>
                        <tr>
                           <th><input class="form-check-input form-check-input-lg" type="checkbox" id="inlineCheckbox1" value="option1" onChange={handleSelectAll} 
    checked={selected.select_order_id.length === state.length && state.length > 0}/></th>
                            <th class="border-gray-200">Invoice No. #</th>
                            <th class="border-gray-200">Customer</th>
                            <th class="border-gray-200">State</th>
                            <th class="border-gray-200">GST/PAN</th>
                            <th class="border-gray-200">Invoice Date</th>
                            <th class="border-gray-200">Invoice Period</th>
                            <th class="border-gray-200">Invoice Amount</th>
                            <th class="border-gray-200">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                       
                        {state.map((sub)=>(

                       
                        <tr>
                              <td><input class="form-check-input form-check-input-lg" type="checkbox" checked={selected.select_order_id.some(item => item.invoice_id === sub.invoice_id)} 
    onChange={(e) => handleChangeSelected(e, sub)}/></td>
                            <td>
                            <strong>{sub.invoice_id}</strong>
                            </td>  
                            <td>
                                {sub.company_name?sub.company_name:sub.full_name?sub.full_name:""}
                            </td>       
                            <td>
                                {sub.state_name?sub.state_name:sub.state_name?sub.state_name:""}
                            </td>       
                            <td>
                                {sub.gst_number && sub.gst_number!="undefined"?`${sub.gst_number}`:sub.pan_number?`${sub.pan_number}`:""}
                            </td>                      
                            <td>
                                {sub.invoice_date}
                            </td>  
                            <td>
                               {sub.invoice_period}
                            </td>
                            <td>
                                ₹{sub.amount?sub.amount:0}
                            </td>
                            <td class="fw-700">
                                <a onClick={(e)=>get_shipments(sub)} class="btn btn-outline-primary me-2"><i class="fa fa-file-excel-o" aria-hidden="true"></i></a>
                                <a onClick={()=>next_step(sub)} class="btn btn-primary"><i class="fa fa-file-pdf-o" aria-hidden="true"></i></a>
                            </td>
                        </tr>
                         ))}
                    </tbody>
                </table>
            </div> 
}

    </section>
    </div> 
    </section>              




{/* <?php
include('footer.php');
?>   */}
    </div>
  )
}

export default Customer_invoices
